import React from 'react';
import cn from 'classnames';
import { Image, TDeviceType } from '@cian/ui-kit';

import videoIcon from './assets/video-icon.svg';

import * as styles from './styles.css';

export const HeroSectionActions: React.FC<{
  onOpenVideoClick(): void;
  onCreateDealClick(): void;
  deviceType: TDeviceType;
}> = props => {
  return (
    <div className={cn(styles['actions'], styles[props.deviceType])}>
      <button
        data-testid="create-deal-button"
        onClick={props.onCreateDealClick}
        className={cn(styles['actions-button'], styles['actions-button-create-deal'])}
      >
        Провести сделку
      </button>
      <button
        data-testid="about-deal-button"
        onClick={props.onOpenVideoClick}
        className={cn(styles['actions-button'], styles['actions-button-watch-video'])}
      >
        <Image display="inline-block" src={videoIcon} width={16} height={16} loading="lazy" /> Как проходит сделка
      </button>
    </div>
  );
};
